export enum UserType {
    STANDARD = 'STANDARD',
    EXTRA_UE = 'EXTRA_UE',
    EIDAS = 'EIDAS'
}

export class UserTypeUtil {
    static getDisplayName(userType: UserType): string {
        switch (userType) {
            case UserType.STANDARD:
                return 'Utente Standard';
            case UserType.EXTRA_UE:
                return 'Utente Extra UE';
            case UserType.EIDAS:
                return 'Utente eIDAS';
            default:
                return 'Utente Standard';
        }
    }

    static isExtraUE(userType: UserType): boolean {
        return userType === UserType.EXTRA_UE;
    }

    static isEIDAS(userType: UserType): boolean {
        return userType === UserType.EIDAS;
    }

    static isStandard(userType: UserType): boolean {
        return userType === UserType.STANDARD;
    }
}